import type { MessageDescriptor } from 'react-intl';

import { fantasy } from '@sorare/core/src/lib/glossary';

import {
  AnySportPlayerScoreStats,
  BaseballPlayerScoreStats,
  FootballPlayerScoreStats,
  NBAPlayerScoreStats,
} from './types.ts';

const footballStatTitle = {
  [FootballPlayerScoreStats.DS]: fantasy.decisiveScoreShort,
  [FootballPlayerScoreStats.AA]: fantasy.allAroundShort,
};

const baseballStatTitle = {
  [BaseballPlayerScoreStats.TOTAL_SCORE]: {
    defaultMessage: 'Total score',
  },
  [BaseballPlayerScoreStats.AB]: {
    defaultMessage: 'AB',
  },
  [BaseballPlayerScoreStats.R]: {
    defaultMessage: 'R',
  },
  [BaseballPlayerScoreStats.H]: {
    defaultMessage: 'H',
  },
  [BaseballPlayerScoreStats.RBI]: {
    defaultMessage: 'RBI',
  },
  [BaseballPlayerScoreStats.HR]: {
    defaultMessage: 'HR',
  },
  [BaseballPlayerScoreStats.BB]: {
    defaultMessage: 'BB',
  },
  [BaseballPlayerScoreStats.K]: {
    defaultMessage: 'K',
  },
  [BaseballPlayerScoreStats.AVG]: {
    defaultMessage: 'AVG',
  },
  [BaseballPlayerScoreStats.OBP]: {
    defaultMessage: 'OBP',
  },
  [BaseballPlayerScoreStats.SLG]: {
    defaultMessage: 'SLG',
  },
  [BaseballPlayerScoreStats.MATCHUPS]: {
    defaultMessage: 'Matchups',
  },
  [BaseballPlayerScoreStats.L5]: {
    defaultMessage: 'L5',
  },
  [BaseballPlayerScoreStats.L15]: {
    defaultMessage: 'L15',
  },
};

const nbaStatTitle: Record<NBAPlayerScoreStats, MessageDescriptor> = {
  [NBAPlayerScoreStats.L10]: fantasy.l10,
  [NBAPlayerScoreStats.DIFF]: {
    defaultMessage: 'DIFF.',
  },
  [NBAPlayerScoreStats.MIN]: {
    defaultMessage: 'MIN',
  },
  [NBAPlayerScoreStats.THREE_PT]: {
    defaultMessage: '3PT',
  },
  [NBAPlayerScoreStats.REB]: {
    defaultMessage: 'REB',
  },
  [NBAPlayerScoreStats.AST]: {
    defaultMessage: 'AST',
  },
  [NBAPlayerScoreStats.STL]: {
    defaultMessage: 'STL',
  },
  [NBAPlayerScoreStats.BLK]: {
    defaultMessage: 'BLK',
  },
  [NBAPlayerScoreStats.TO]: {
    defaultMessage: 'TO',
  },
  [NBAPlayerScoreStats.PTS]: {
    defaultMessage: 'PTS',
  },
  [NBAPlayerScoreStats.GAMES]: {
    defaultMessage: 'Games',
  },
  [NBAPlayerScoreStats.TOT]: {
    defaultMessage: 'TOT',
  },
};

export const playerStatTitle = {
  [AnySportPlayerScoreStats.SCORE]: fantasy.score,
  [AnySportPlayerScoreStats.PROJECTED_SCORE]: fantasy.projectedScoreShort,
  [AnySportPlayerScoreStats.GAIN_ON_PROJECTION]: fantasy.gainOnProjection,
  [AnySportPlayerScoreStats.FORM]: {
    defaultMessage: 'Form',
  },
  [AnySportPlayerScoreStats.PRICE]: {
    defaultMessage: 'Price',
  },
  ...footballStatTitle,
  ...baseballStatTitle,
  ...nbaStatTitle,
};
